import styles from "./Modal.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import ReactModal from "react-modal";

export function Modal({ children, ...props }) {
  return (
    <ReactModal
      {...props}
      closeTimeoutMS={200}
      className={{
        base: styles.modal,
        afterOpen: styles.modalAfterOpen,
        beforeClose: styles.modalBeforeClose,
      }}
      overlayClassName={{
        base: styles.overlay,
        afterOpen: styles.overlayAfterOpen,
        beforeClose: styles.overlayBeforeClose,
      }}
    >
      {children}
    </ReactModal>
  );
}

/**
 * Optional helper component for content padding and alignment.
 */
export function ModalContent({ children }) {
  return <div className={styles.content}>{children}</div>;
}

/**
 * Optional pre-styled header for modals. Goes inside a ModalContent.
 */
export function ModalHeader({ children }) {
  return (
    <header className={styles.header}>
      <h2>{children}</h2>
    </header>
  );
}

/**
 * Optional helper component for controls padding and alignment.
 */
export function ModalControls({ children }) {
  return <div className={styles.controls}>{children}</div>;
}

Modal.propTypes = {};
